export default (state = {}, action) => {
  switch (action.type) {
    case 'ADD_SUB_MENU_ESPEC_ID':
      return { ...state, idSubMenuEspec: action.idSubMenuEspec };
    case 'ADD_MODULO_SUB_MENU_ID':
      return { ...state, idModuloSubMenu: action.idModuloSubMenu };
    case 'ADD_MENU_SUB_MENU_ID':
      return { ...state, idMenuSubMenu: action.idMenuSubMenu };
    case 'ADD_SUB_MENU_ID':
      return { ...state, idSubMenu: action.idSubMenu };
    default:
      return state;
  }
};
